import api from '@/lib/axios';

export const auditService = {
  async findAll(params: {
    companyId: string;
    branchId?: string;
    action?: string;
    entity?: string;
    userId?: string;
    page?: number;
    limit?: number;
  }) {
    const response = await api.get('/audit', { params });
    return response.data;
  },
};
